export default "__VITE_ASSET__DNOfCy16__"